import React from 'react';
import Header from './components/Header';
import Projects from './components/Projects';
import WorkExperience from './components/WorkExperience';
import Education from './components/Education';
import GameJams from './components/GameJams';
import Sidebar from './components/Sidebar';
import NavigationBar from './components/NavigationBar';

function App() {
  return (
    <div className="wrapper">
      {/* Main Content */}
       <div className="main-content">
        <Header />
        <hr style={{ border: 'none', borderTop: '2px solid #fff', margin: '2rem 0' }} />
        <Projects />
        <hr style={{ border: 'none', borderTop: '2px solid #fff', margin: '2rem 0' }} />
        <WorkExperience />
        <hr style={{ border: 'none', borderTop: '2px solid #fff', margin: '2rem 0' }} />
        <Education />
        <hr style={{ border: 'none', borderTop: '2px solid #fff', margin: '2rem 0' }} />
        <GameJams />
      </div>

      {/* Sidebar */}
      <Sidebar />
      <NavigationBar />
    </div>
  );
}

export default App;
